module.exports = __webpack_public_path__ + "img/resumeExists.3674e783.svg";